import React, { useContext, useState,useEffect } from 'react';
import Header from './header';
import CircularProgress from '@mui/material/CircularProgress';
import {
    Navigate,
    Link,
    NavLink,
    useNavigate,
    useParams
  } from "react-router-dom";
  import { AppContext } from '../context';
  import { holdUser } from "../features/userdataSlice";

import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import axios from 'axios';
import  secureLocalStorage  from  "react-secure-storage";

function Otp () {
 const { storage } = useContext(AppContext);
   
    const [showOrder, setShowOrder] = useState(false);
      const [userData, setuserData] = useState('');
    const dispatch = useDispatch();
    const [user, setUser] = useState({ parent_name: '', parent_email: '', parent_email: '' });
    const [successMsg, setSuccessMsg] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [loader, setLoader] = useState(false);
    const [password, setPassword] = useState(true);
   
    const { dispatchStorageEvent } = useContext(AppContext);
    const [erroruserid, setErrorUserid] = useState(false);
    const [errorpassword, setErrorPassword] = useState(false);
     const [errorcontact, setErrorcontact] = useState(false);
    const [loginval, setloginval] = useState(0);
 const [loading, setLoading] = useState(false);
    const Axios = axios.create({
        baseURL: storage[0].backEndUrl
        // baseURL: process.env.REACT_APP_ENV_URL
    });
    let navigate = useNavigate();
   
    const [visible, setVisible] = useState(false);

    const logout = (e) => {
      secureLocalStorage.removeItem("username");
      secureLocalStorage.removeItem("userdata");
       
        dispatch(holdUser({}));
        navigate(`/`);
    
      }
  
    React.useEffect(() => {

        if (document.body.classList.contains('body_bg')) {
          document.body.classList.remove('body');
    
        }
        document.body.classList.add('body_bg');
    
      var userid= secureLocalStorage.getItem('usernameotp');;

         console.log(JSON.parse(secureLocalStorage.getItem('userdata')));
        if(userid==null ){
 

          navigate(`/`);

        }else{
         setuserData(JSON.parse(secureLocalStorage.getItem('userdata')));
        }

     
  }, []);

    const handleKeypress = e => {

        //it triggers by pressing the enter key
        if (e.which === 13) {
            handleSubmit();

        }
    };
    const changeUserData = (e) => {
        setErrorUserid(false);
        setErrorPassword(false);
        setErrorcontact(false);
        var user_temp = { ...user };
        if (e.target.name == 'parent_name') user_temp.parent_name = e.target.value;
        if (e.target.name == 'parent_email') user_temp.parent_email = e.target.value;
        if (e.target.name == 'parent_contact') user_temp.parent_contact = e.target.value;
        setUser(user_temp);
    }

      const [otpIn,setOtpin]=useState({
        otpIn_first:"",        
        otpIn_secon:"", 
        otpIn_thir:"",
        otpIn_forth:"",    
        otpIn_fifth:"", 
        otpIn_six:"",     
        error_first:1,  
        error_secon:1,        
        error_thir:1,  
        error_forth:1,  
        error_fifth:1,
        error_six:1,         
        signIn_err:'0',
        signIn_mesage:'',
        status:'fail',
        id:''
      });
  const inputEventOtpIn =(event)=> {
    console.log(event);
    setOtpin((preValue)=>{

      if(event.target.name==='otpIn_first'){
       
        return {    
      otpIn_first:event.target.value,        
      otpIn_secon:preValue.otpIn_secon, 
      otpIn_thir:preValue.otpIn_thir,
      otpIn_forth:preValue.otpIn_forth,    
      otpIn_fifth:preValue.otpIn_fifth, 
      otpIn_six:preValue.otpIn_six,     
      error_first:0,  
      error_secon:preValue.error_secon,        
      error_thir:preValue.error_thir,  
      error_forth:preValue.error_forth,  
      error_fifth:preValue.error_fifth,
      error_six:preValue.error_six,         
      signIn_err:preValue.signIn_err,
      signIn_mesage:'',
      status:'fail',
      id:preValue.id,
                 };
               
        }

        if(event.target.name==='otpIn_secon'){
        
        return {    
      otpIn_first:preValue.otpIn_first,        
      otpIn_secon:event.target.value, 
      otpIn_thir:preValue.otpIn_thir,
      otpIn_forth:preValue.otpIn_forth,    
      otpIn_fifth:preValue.otpIn_fifth, 
      otpIn_six:preValue.otpIn_six,     
      error_first:preValue.error_first,  
      error_secon:0,        
      error_thir:preValue.error_thir,  
      error_forth:preValue.error_forth,  
      error_fifth:preValue.error_fifth,
      error_six:preValue.error_six,         
      signIn_err:preValue.signIn_err,
      signIn_mesage:'',
      status:'fail',
      id:preValue.id,
                 };
                
        }
        if(event.target.name==='otpIn_thir'){
         
          return {    
      otpIn_first:preValue.otpIn_first,        
      otpIn_secon:preValue.otpIn_secon, 
      otpIn_thir:event.target.value,
      otpIn_forth:preValue.otpIn_forth,    
      otpIn_fifth:preValue.otpIn_fifth, 
      otpIn_six:preValue.otpIn_six,     
      error_first:preValue.error_first,  
      error_secon:preValue.error_secon,        
      error_thir:0,  
      error_forth:preValue.error_forth,  
      error_fifth:preValue.error_fifth,
      error_six:preValue.error_six,         
      signIn_err:preValue.signIn_err,
      signIn_mesage:'',
      status:'fail',
      id:preValue.id,
                   };
                  
          }

          if(event.target.name==='otpIn_forth'){
           
            return {    
            otpIn_first:preValue.otpIn_first,        
      otpIn_secon:preValue.otpIn_secon, 
      otpIn_thir:preValue.otpIn_thir,
      otpIn_forth:event.target.value,    
      otpIn_fifth:preValue.otpIn_fifth, 
      otpIn_six:preValue.otpIn_six,     
      error_first:preValue.error_first,  
      error_secon:preValue.error_secon,        
      error_thir:preValue.error_thir,  
      error_forth:0,  
      error_fifth:preValue.error_fifth,
      error_six:preValue.error_six,         
      signIn_err:preValue.signIn_err,
      signIn_mesage:'',
      status:'fail',
      id:preValue.id,
                     };
                    
            }



                if(event.target.name==='otpIn_fifth'){
                
            return {    
            otpIn_first:preValue.otpIn_first,        
      otpIn_secon:preValue.otpIn_secon, 
      otpIn_thir:preValue.otpIn_thir,
      otpIn_forth:preValue.otpIn_forth,    
      otpIn_fifth:event.target.value, 
      otpIn_six:preValue.otpIn_six,     
      error_first:preValue.error_first,  
      error_secon:preValue.error_secon,        
      error_thir:preValue.error_thir,  
      error_forth:preValue.error_forth,  
      error_fifth:0,
      error_six:preValue.error_six,         
      signIn_err:preValue.signIn_err,
      signIn_mesage:'',
      status:'fail',
      id:preValue.id,
                     };
                   
            }
                     if(event.target.name==='otpIn_six'){
        
            return {    
            otpIn_first:preValue.otpIn_first,        
      otpIn_secon:preValue.otpIn_secon, 
      otpIn_thir:preValue.otpIn_thir,
      otpIn_forth:preValue.otpIn_forth,    
      otpIn_fifth:preValue.otpIn_fifth, 
      otpIn_six:event.target.value,     
      error_first:preValue.error_first,  
      error_secon:preValue.error_secon,        
      error_thir:preValue.error_thir,  
      error_forth:preValue.error_forth,  
      error_fifth:preValue.error_fifth,
      error_six:0,         
      signIn_err:preValue.signIn_err,
      signIn_mesage:'',
      status:'fail',
      id:preValue.id,
                     };
            }
        });
        if(event.target.name==='otpIn_first'){
       
          document.getElementById('otpIn_secon').focus();
 }

 if(event.target.name==='otpIn_secon'){

          document.getElementById('otpIn_thir').focus();
 }
 if(event.target.name==='otpIn_thir'){
 
 
            document.getElementById('otpIn_forth').focus();
   }

   if(event.target.name==='otpIn_forth'){
 
  
           //   document.getElementById('otpIn_fifth').focus();
     }



    //      if(event.target.name==='otpIn_fifth'){
 
 
    //           document.getElementById('otpIn_six').focus();
    //  }
    console.log( otpIn);
    
  } 
    const handleSubmit = (event) => {

        setErrorMsg('');
        setSuccessMsg('');
        setErrorUserid(false);
        setErrorPassword(false);
        setErrorcontact(false);
        if(otpIn.otpIn_first ==''  ||  otpIn.otpIn_secon ==''    
        ||  otpIn.otpIn_thir ==''   ||  otpIn.otpIn_forth =='' )
   {  setErrorMsg('Please Enter Valid otp'); return false; }
        var otp= otpIn.otpIn_first+otpIn.otpIn_secon+otpIn.otpIn_thir+otpIn.otpIn_forth+otpIn.otpIn_fifth+otpIn.otpIn_six;
        setLoader(true);
        Axios.post(`/otp_update`, { stuid: userData.stuid, otp: otp})
            .then(res => {
                console.log(res.data);

                if (res.data.status == true) {
                  console.log(res.data.consentForm);
                    storage[0].userdata = res.data.data;
                    secureLocalStorage.setItem("userdata", JSON.stringify(res.data.data));
                    secureLocalStorage.setItem('username', res.data.data.stuid);
                    secureLocalStorage.setItem('userlogin', res.data.data.stuid);
                    secureLocalStorage.removeItem("usernameotp");
                    secureLocalStorage.setItem('consentForm', (res.data.consentForm));
                    secureLocalStorage.setItem('allloactions', (res.data.locations));
                    secureLocalStorage.setItem("studenentformdata", JSON.stringify(res.data.studentdata));
                    dispatchStorageEvent(storage);
                    setSuccessMsg('OTP verfied  Successfully!');

                    setLoader(false);
                    setloginval(2);





                }
                else {
                    setloginval(0);
                    setErrorMsg(res.data.message);
                         setOtpin((preValue)=>{
              
              return {    
                 otpIn_first:'',        
       otpIn_secon:'', 
       otpIn_thir:'',
       otpIn_forth:'',    
       otpIn_fifth:'', 
       otpIn_six:'',     
          error_first:0,  
       error_secon:0,        
       error_thir:0,  
       error_forth:0,  
       error_fifth:0,
       error_six:0,         
       
                       };
              })
                    setLoader(false);
                }
            });
    }
      if (loginval == 2) {
        return <Navigate to='/instruction' />;
    }   
  return (
    <>
    <Header />
    
   <div className='regis-main-sec'>
    <div className='container'>

        <div className='row'>
            <div className='col-md-12'>
                <div className='regis-head'>
                    <h2>2 Factor Authentication </h2>
                  
                </div>
            </div>
        </div>

        <div className='regis-form-sec otp-main-sec'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='otp-content'>
                            <p>A 4 digit code has been sent to your registered email id,
                                please check spam folder in case it isn't in your inbox
                            </p>
                        </div>
                        <div className='otp-form form__group inputs d-flex flex-row justify-content-center mt-2'>
                            <input class="text-center form-control rounded otp-sec-input" type="text"  maxlength="1"  name="otpIn_first"  id="otpIn_first" onChange={inputEventOtpIn} value={otpIn.otpIn_first}  /> 
                            <input class="text-center form-control rounded otp-sec-input" type="text"  maxlength="1" name="otpIn_secon"  id="otpIn_secon" onChange={inputEventOtpIn} value={otpIn.otpIn_secon} /> 
                            <input class="text-center form-control rounded otp-sec-input" type="text" maxlength="1"  name="otpIn_thir" id="otpIn_thir" onChange={inputEventOtpIn} value={otpIn.otpIn_thir} /> 
                            <input class="text-center form-control rounded otp-sec-input" type="text" maxlength="1"  name="otpIn_forth"  id="otpIn_forth"  onChange={inputEventOtpIn} value={otpIn.otpIn_forth}  /> 
                        </div>
                       
                        <div className='login-submit login-otp' style={{textAlign:'center'}}>
                            
                                <button className='btn btn-login btn-login-sumt btn-reg-submt btn-otp' onClick={handleSubmit}>SUBMIT
                                 {
                                                                        loader != '' ?
                                                                            <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff",position:'absolute',marginTop:'3px' }} />
                                                                            :  ''

                                                                    }</button>
                             {
                                                                    loader != '' ? <div className="success-msg success-new-msg">
                                                                        <p className="success-msg">Please wait while we get you access to the system</p>

                                                                    </div> :
                                                                    <div className="success-msg success-new-msg" >
                                                                    <p className="success-msg" style={{ visibility: 'hidden' }} >Please wait while we fetch your data</p>
                                                                </div>
                                                                }
                                                             
                                                                {
                                                                    successMsg != '' ? <div className="success-msg">
                                                                        <p className="success-msg">{successMsg}</p>
                                                                    </div> : ''
                                                                }


                                                                {
                                                                    errorMsg != '' ? <div className="error-msg" >
                                                                        <p className="error-msg">{errorMsg}</p>
                                                                    </div> : <div className="error-msg" style={{ visibility: 'hidden' }} >
                                                                        <p className="error-msg">Wrong credentials!</p>
                                                                    </div>
                                                                }
                        </div>

                    </div>
                </div>
        </div>

        </div>
    </div>
</>
  )
}

export default Otp;

